<script>
import _ from 'lodash'

export default {
  methods: {
    contentFilter (cityFilter) {
      let reset = {
        id: -1,
        name: 'Alle'
      }

      this.$store.commit('setEventLoader', true)
      this.$store.commit('setNewsLoader', true)

      if (this.$refs.newsSlider.$refs.news !== undefined) {
        this.$refs.newsSlider.$refs.news.goToPage(0)
      }

      if (this.$refs.agendaSlider.$refs.agenda !== undefined) {
        this.$refs.agendaSlider.$refs.agenda.goToPage(0)
      }

      Object.keys(this.items).forEach((key) => {
        this.filterSlides(reset, key)

        if (cityFilter.id === -1) {
          this.items[key].cloned = this.items[key].original
        } else {
          let city = 'address.city'

          if (key === 'news') {
            city = 'surrounding.data.city'
          }

          this.items[key].cloned = this.items[key].original.filter(item => _.get(item, city) === cityFilter.city)
        }

        this.setAvailableFilters(this.items[key].cloned, key)

        setTimeout(() => {
          this.$store.commit('setEventLoader', false)
          this.$store.commit('setNewsLoader', false)
        }, 200)
      })
    },
    filterDirectories (filter, items) {
      let filteredItems = []

      if (filter.id === -1) {
        filteredItems = items
      } else {
        filteredItems = items.filter((item) => {
          if (item.branche.id !== undefined) {
            return item.branche.id === filter.id
          }
        })
      }

      return filteredItems
    },
    filterDiscounts (filter, discounts) {
      if (filter.id === -1) {
        return discounts
      } else {
        return discounts.filter(discount => discount.branche === filter.id)
      }
    },
    filterSlides (filter, name) {
      if (name === 'news') {
        this.$store.commit('setNewsLoader', true)
      } else {
        this.$store.commit('setEventLoader', true)
      }
      this.$store.commit('setCurrentFilter', { name: name, filter: filter })

      if (filter.id === -1 && this.$store.state.contentFilter.id === -1) {
        this.items[name].cloned = this.items[name].original
      } else {
        let currentCity = this.$store.state.contentFilter
        let originalItems = this.items[name].original

        if (currentCity.id !== -1) {
          let city = 'address.city'

          if (name === 'news') {
            city = 'surrounding.data.city'
          }

          originalItems = originalItems.filter(item => _.get(item, city) === currentCity.city)
        }

        if (filter.id === -1) {
          this.items[name].cloned = originalItems

          setTimeout(() => {
            if (name === 'news') {
              this.$store.commit('setNewsLoader', false)
            } else {
              this.$store.commit('setEventLoader', false)
            }
          }, 200)

          return
        }

        this.items[name].cloned = originalItems.filter((item) => {
          let branche
          let brancheId

          if (name === 'news') {
            branche = item.surrounding.data.branche
            if (branche !== undefined) {
              brancheId = item.surrounding.data.branche.data.id
            }
          }

          if (name === 'events') {
            branche = item.surrounding.branche
            if (branche !== null) {
              brancheId = item.surrounding.branche.id
            }
          }

          if (brancheId !== undefined) {
            return brancheId === filter.id
          }
        })
      }

      setTimeout(() => {
        if (this.$refs.newsSlider.$refs.news !== undefined) {
          this.$refs.newsSlider.$refs.news.goToPage(0)
        }

        if (this.$refs.agendaSlider.$refs.agenda !== undefined) {
          this.$refs.agendaSlider.$refs.agenda.goToPage(0)
        }

        if (name === 'news') {
          this.$store.commit('setNewsLoader', false)
        } else {
          this.$store.commit('setEventLoader', false)
        }
      }, 200)
    },
    setAvailableFilters (items, type) {
      this.items[type].filter = [{
        id: -1,
        name: 'Alle'
      }]

      items.forEach((item) => {
        let branche
        let position = null

        if (type === 'news') {
          if (item.surrounding.data.branche !== undefined) {
            branche = {
              id: item.surrounding.data.branche.data.id,
              name: item.surrounding.data.branche.data.name
            }
          }
        }

        if (type === 'events') {
          if (item.surrounding) {
            if (item.surrounding.branche !== null) {
              branche = {
                id: item.surrounding.branche.id,
                name: item.surrounding.branche.name
              }
            }
          }
        }

        if (branche !== undefined) {
          position = this.items[type].filter.map((it) => {
            return it.id
          }).indexOf(branche.id)
        }

        if (position === -1 && branche !== undefined) {
          this.items[type].filter.push(branche)
        }
      })
    }
  }
}
</script>
